var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"\"></h4>\n<hr/>\n</div>";
var id1="service_assignment_rules.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_control/component/service_assignment_rules/edit/service_assignment_rules.edit.html
// module id = 2864
// module chunks = 1